import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";

import Greeting from "components/Common/Greeting";
import ModalDelete from "components/Common/ModalDelete";
import ModalProfile from "components/Common/ModalProfile";
import ModalWarning from "components/Common/ModalWarning";
import NewResponseModal from "components/Pages/Responses/ResponsesSideBar/NewResponseModal";
import EditResponseModal from "components/Pages/Responses/ResponsesHeader/EditResponseModal";
import ModalBillingPayment from "components/Common/ModalBillingPayment";
import ModalBillingCustomer from "components/Common/ModalBillingCustomer";
import ModalBillingPlans from "components/Common/ModalBillingPlans";
import ModalEditTraining from "components/Common/ModalEditTraining";
import ModalZendeskTicketingConfig from "components/Pages/Settings/SettingsHandoff/ModalZendeskTicketingConfig";
import SettingsPlatformsAdaMessengerModal from "components/Pages/Settings/SettingsPlatforms/SettingsPlatformsAdaMessengerModal";
import SettingsPlatformsChatModal from "components/Pages/Settings/SettingsPlatforms/SettingsPlatformsChatModal";
import SettingsPlatformsMessengerModal from "components/Pages/Settings/SettingsPlatforms/SettingsPlatformsMessengerModal";
import SettingsPlatformsSmsModal from "components/Pages/Settings/SettingsPlatforms/SettingsPlatformsSmsModal";
import SettingsPlatformsZendeskModal from "components/Pages/Settings/SettingsPlatforms/SettingsPlatformsZendeskModal";
import ZendeskAgentWorkspaceModal from "components/Pages/Settings/SettingsPlatforms/ZendeskAgentWorkspaceModal";
import SettingsPlatformsNuanceLAModal from "components/Pages/Settings/SettingsPlatforms/LiveAgents/SettingsPlatformsNuanceLAModal";
import SalesforceLAModal from "components/Pages/Settings/SettingsPlatforms/LiveAgents/SalesforceLAModal";
import ConversationsChatterModal from "components/Pages/Conversations/ConversationsChatter/ConversationsChatterModal";
import SettingsSatisfactionModal from "components/Pages/Settings/SettingsSatisfaction/SettingsSatisfactionModal";
import AuthenticationModal from "components/Pages/Settings/SettingsAuthentication/SettingsAuthenticationModal";
import SettingsSchedulesModal from "components/Pages/Settings/SettingsSchedules/SettingsSchedulesModal";
import BotRoutingConfig from "components/Pages/Settings/SettingsHandoff/ModalBotRoutingConfig";
import ModalExpiredPassword from "components/Common/ModalExpiredPassword";
import ModalEnforceMFA from "components/Common/ModalEnforceMFA";
import ModalBulkAddTraining from "components/Pages/Responses/ResponsesEditor/ResponseEditorTrainer/ModalBulkAddTraining";
import ModalMoveTraining from "components/Pages/Responses/ResponsesEditor/ResponseEditorTrainer/ModalMoveTraining";
import AnalyticsYearEndWrapUpReportModal from "components/Pages/AnalyticsPage/AnalyticsReportsPage/AnalyticsYearEndWrapUpReport/AnalyticsYearEndWrapUpReportModal";

import classnames from "classnames";
import Button from "components/Common/Button";
import { setState } from "actions";
import { closeModalAction } from "actions/modal";
import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";

class Modal extends React.Component {
  constructor(...args) {
    super(...args);

    this.handleClose = this.handleClose.bind(this);
  }

  /**
   * Hooks
   */

  /**
   * @param {Object} prevProps
   */
  componentDidUpdate(prevProps) {
    if (prevProps.modal.view !== this.props.modal.view) {
      const input = document
        .getElementById("modal")
        .getElementsByTagName("input")[0];

      if (input) {
        input.focus();
      }
    }
  }

  /**
   * Getters
   */

  /**
   * @returns {Boolean}
   */
  get isGreetingModal() {
    const { modal } = this.props;

    switch (modal.view) {
      case "MODAL_GREETING":
        return true;
      default:
        return false;
    }
  }

  /**
   */
  handleClose() {
    const { closeModal, modal } = this.props;
    const onClose = modal.getIn(["modalProps", "onClose"]);

    closeModal();

    if (onClose) {
      onClose();
    }
  }

  /**
   * Methods
   */

  /**
   * @returns {ReactElement}
   */
  render() {
    const modalComponents = {
      MODAL_PROFILE: ModalProfile,
      SETTINGS_PLATFORMS_ADA_MESSENGER_MODAL: SettingsPlatformsAdaMessengerModal,
      SETTINGS_PLATFORMS_CHAT_MODAL: SettingsPlatformsChatModal,
      SETTINGS_PLATFORMS_MESSENGER_MODAL: SettingsPlatformsMessengerModal,
      SETTINGS_PLATFORMS_SMS_MODAL: SettingsPlatformsSmsModal,
      SETTINGS_PLATFORMS_ZENDESK_CHAT_MODAL: SettingsPlatformsZendeskModal,
      SETTINGS_PLATFORMS_NUANCE_LIVEAGENT_MODAL: SettingsPlatformsNuanceLAModal,
      SETTINGS_PLATFORMS_SALESFORCE_LIVEAGENT_MODAL: SalesforceLAModal,
      SETTINGS_PLATFORMS_ZENDESK_LIVEAGENT_MODAL: SettingsPlatformsZendeskModal,
      SETTINGS_PLATFORMS_ZAW_LIVEAGENT_MODAL: ZendeskAgentWorkspaceModal,
      MODAL_BILLING_PAYMENT: ModalBillingPayment,
      MODAL_BILLING_PLANS: ModalBillingPlans,
      MODAL_BILLING_CUSTOMER: ModalBillingCustomer,
      MODAL_ZENDESK_TICKETING_CONFIG: ModalZendeskTicketingConfig,
      CONVERSATIONS_CHATTER_MODAL: ConversationsChatterModal,
      NEW_RESPONSE_MODAL: NewResponseModal,
      EDIT_RESPONSE_MODAL: EditResponseModal,
      MODAL_WARNING: ModalWarning,
      MODAL_DELETE: ModalDelete,
      MODAL_GREETING: Greeting,
      SETTINGS_SATISFACTION_MODAL: SettingsSatisfactionModal,
      MODAL_AUTHENTICATION: AuthenticationModal,
      MODAL_BOT_ROUTING_CONFIG: BotRoutingConfig,
      SETTINGS_SCHEDULES_MODAL: SettingsSchedulesModal,
      MODAL_ENFORCE_MFA: ModalEnforceMFA,
      MODAL_PASSWORD_EXPIRE: ModalExpiredPassword,
      MODAL_MOVE_TRAINING: ModalMoveTraining,
      MODAL_BULK_TRAINING: ModalBulkAddTraining,
      MODAL_ANALYTICS_WRAP_UP_REPORT: AnalyticsYearEndWrapUpReportModal,
      MODAL_EDIT_TRAINING: ModalEditTraining
    };

    const CurrentModal = modalComponents[this.props.modal.view];
    const showGreetingModal = this.isGreetingModal;

    const isSmall = Boolean(CurrentModal && CurrentModal.isSmall);
    const isLarge = Boolean(CurrentModal && CurrentModal.isLarge);
    const isUnClosable = this.props.modalOpenState.get("isUnClosable");
    const hasOpacityTransition = Boolean(CurrentModal && CurrentModal.hasOpacityTransition);
    const closeButtonColor = CurrentModal && CurrentModal.closeButtonColor;

    return (
      <div
        id="modal"
        className={
          classnames(
            "Modal",
            {
              "Modal--small": isSmall,
              "Modal--large": isLarge,
              "Modal--has-opacity-transition": hasOpacityTransition,
              "Modal--active": this.props.modal.isOpen
            }
          )
        }
      >
        {/* No need to make mask accessible */}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div className="Modal__mask" onClick={isUnClosable ? null : this.handleClose} />
        <div
          className={
            classnames(
              "Modal__container",
              {
                "Modal__container--small": isSmall,
                "Modal__container--large": isLarge,
                "Modal__container--has-opacity-transition": hasOpacityTransition,
                "Modal__container--greeting": showGreetingModal
              }
            )
          }
        >
          <div className="Modal__inner-container">
            {!isUnClosable && (
              <Button
                icon="Close"
                title="Close Modal"
                clear
                onClick={this.handleClose}
                fillColor={closeButtonColor || colors.colorGrey4}
                customClassName="Modal__container__close"
              />
            )}
            {!!CurrentModal && (
              <CurrentModal
                _b="Modal"
                // TODO: Determine how to spread immutable attributes so we don't need toObject()
                // Using toObject vs toJS so it doesn't convert immutable objects to regular objects
                {...this.props.modal.modalProps.toObject()}
                setState={this.props.setState}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  setState: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  modal: ImmutablePropTypes.record.isRequired
};

function mapState(state) {
  const { modal, modalOpenState } = state;

  return { modal, modalOpenState };
}

function mapDispatch(dispatch) {
  return {
    setState: bindActionCreators(setState, dispatch),
    closeModal: bindActionCreators(closeModalAction, dispatch)
  };
}

const Connector = connect(
  mapState,
  mapDispatch
)(Modal);

export default Connector;
